module.exports = __webpack_public_path__ + "static/img/tjysbj_ysfa_icon.png";